<template>
    <div class="col-sm-12 nopads">
        <div class="search-form">
            <div class="col-sm-12 search-form-title px-2">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>

            <!-- Form using Bootstrap classes -->
            <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="form-inline no-margin">
                <div class="row px-2 mb-2">
                    <div class="col-sm-6">
                        <area-filter ref="areaFilter" :no-geom="true" @area-set="setArea"/>
                    </div>
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('equipment.name') }}</span>
                        <div class="form-group nopads">
                            <input
                                id="equipment_name"
                                v-model="name"
                                type="text"
                                class="form-control form-control-sm"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-12 text-end my-2 px-2">
                    <button type="submit" class="btn btn-primary form-button">
                        {{ $t('ins_report.search') }}
                    </button>
                    <button type="reset" class="btn btn-danger form-button">
                        {{ $t('ins_report.clear') }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Loading Spinner -->
        <div v-if="loading" id="loader" class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import AreaFilter from '../AreaFilter'

export default {
    name: 'AreaEquipmentFilter',
    components: {AreaFilter},
    mixins: [restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            name: null,
            area: null,
        }
    },

    mounted: function () {
    },

    methods: {
        onReset: function () {
            this.name = null
            this.area = null
            this.$refs.areaFilter.resetData()
        },
        onSubmit: function () {
            var params = {}
            if (this.area) {
                params.area = this.area.id
            }
            if (this.name) {
                params.name = this.name
            }
            this.$emit('search', params)
        },

        setArea: function (area) {
            this.area = area
        }
    }
}
</script>

<style scoped>

</style>
